import { qrCodewords } from './qrCodewords';
import { drawFormatBits, qrBaseGrid } from './qrFunctionPatterns';
import { qrPenalty } from './qrPenalty';
import { applyMask, placeCodewords } from './qrPlacement';

/**
 * Матриця QR-коду тексту (UTF-8, байтовий режим, рівень корекції M, найменша версія до 20): службові шаблони, кодові слова, маска з
 * найменшим штрафом і форматне слово. true — темний модуль, [рядок][стовпець], без тихої зони. null — текст задовгий. Чиста функція.
 */
export function qrMatrix(text: string): boolean[][] | null {
  const encoded = qrCodewords(new TextEncoder().encode(text));
  if (!encoded) return null;
  const grid = qrBaseGrid(encoded.version);
  placeCodewords(grid, encoded.codewords);
  let best = 0;
  let bestPenalty = Infinity;
  for (let mask = 0; mask < 8; mask++) {
    applyMask(grid, mask);
    drawFormatBits(grid, mask);
    const penalty = qrPenalty(grid.modules, grid.size);
    if (penalty < bestPenalty) { best = mask; bestPenalty = penalty; }
    applyMask(grid, mask);
  }
  applyMask(grid, best);
  drawFormatBits(grid, best);
  return Array.from({ length: grid.size }, (_, y) => grid.modules.slice(y * grid.size, (y + 1) * grid.size));
}
